import React from 'react';

import {observer} from 'mobx-react';
import classNames from "classnames";
import {APP} from "../../../app/consts";
import {BookmakerStripLogo} from "../../bookmaker-strip/bookmaker-strip-logo";
import styles from './base.title.module.scss';
import {useBookieClick} from "../../../../infrastructure/hooks/useBookieClick";

export const BaseSideTitleBookmaker = observer(({controller, bookmaker, source, sportTypeId}) => {
  const currentLinkModelName: String = controller?.state?.currentLinkModel?.name;
  const isSmallView = controller?.state?.device.isSmallView;

  const {bookieHrefModel, onBookieClick} = useBookieClick(controller, {
    bookieId: bookmaker?.id,
    bookieName: bookmaker?.name,
    urlLink: bookmaker?.link,
    widget: APP.ANALYTICS.WIDGET_TYPES[currentLinkModelName],
    impressionType: APP.ANALYTICS.BETS_IMPRESSION_TYPES.odds,
    hasOdds: !!bookmaker,
    currentLinkModelName,
    source
  });

  const betsImpressionParams = {
    bookieId: bookmaker?.id,
    bookieName: bookmaker?.name,
    sportTypeId
  };

  const bookmakerStripLogoProps = {
    controller,
    betsImpressionParams,
    className: classNames({[styles.small_view]: isSmallView}, styles.bookie_logo),
    bookmaker,
    logoWidth: 60,
    bookieHrefModel,
    clickable: bookmaker && onBookieClick,
    onClick: () => onBookieClick?.(bookmaker)
  }

  return bookmaker ? <BookmakerStripLogo {...bookmakerStripLogoProps}/> : null
});

